<template>
    <div class="popup profile-wrap">
        <vue-headful title="Welcome" description="Welcome"/>
        <div class="title"> Welcome
            <div class="close">
                <router-link to="/"><img src="/img/profile/close-x.svg"/></router-link>
            </div>
        </div>
        <hr class="hr"/>
        <div class="popup-body">
            <div style="margin: 15px"><img src="/img/profile/success.svg"/></div>
            <div> Your email has been confirmed</div>
            <a style="margin-top: 15px; margin-bottom: 30px; color: #fff;" href="/sign-in"
               class="btn btn-success btn-blue">Go to sign in</a></div>
    </div>
</template>

<script>
    export default {};
</script>
